"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const db_mapper_1 = __importDefault(require("../base/db-mapper"));
const wallboard_model_1 = __importDefault(require("./wallboard.model"));
class WallboardMapper extends db_mapper_1.default {
    loadWithSort(companyID, wallboardID) {
        return new Promise((resolve, reject) => {
            const params = {
                TableName: this.getDBName(),
                Key: { ID: companyID, wallboardID: wallboardID },
            };
            this.db.get(params, (err, data) => {
                if (err) {
                    console.log(`Error loading ${this.name} with ID ${companyID} ` +
                        `and wallboardID ${wallboardID}`, err);
                    return reject(err);
                }
                if (!data.Item) {
                    console.log(`${this.name} with ID ${companyID} and ` +
                        `wallboardID ${wallboardID} does not exist`);
                    // @ts-ignore
                    return resolve();
                }
                console.log(`successfully loaded ${this.name} with ID ${companyID} ` +
                    `and wallboardID ${wallboardID}`);
                const result = this.newModel(data.Item);
                return resolve(result);
            });
        });
    }
    async delete(wb) {
        const params = {
            TableName: this.getDBName(),
            Key: {
                ID: wb.ID,
                wallboardID: wb.wallboardID,
            },
        };
        console.log(`deleting ${this.name} with ID ${wb.ID} and`, `wallboard ID ${wb.wallboardID}`);
        try {
            await this.db.delete(params).promise();
            console.log(`successfully deleted ${this.name} with ID ${wb.ID} and`, `wallboard ID ${wb.wallboardID}`);
            return;
        }
        catch (ex) {
            console.log(`error deleting ${this.name} with ID ${wb.ID} and`, `wallboard ID ${wb.wallboardID}`);
            throw expect;
        }
    }
    /**
     * Update wallboard in database. Only updates modified properties.
     *
     * @param cID The company ID of the wallboard
     * @param wID The ID of the wallboard
     * @param update The object containing the changes to the wallboard config
     */
    async updateWithSort(cID, wID, update) {
        // Check update properties are valid
        const dummyConfig = {
            connectURL: "",
            key: "",
            secret: "",
            region: "",
            accessToken: "",
            companyName: "",
            companyLogoURL: "",
            dashboardName: "",
            queues: [],
        };
        const testWallboard = this.newModel({
            ID: "",
            wallboardID: -1,
            config: Object.assign(dummyConfig, update),
        });
        const testResults = this.validate(testWallboard);
        if (testResults && testResults.errors.length > 0)
            throw { code: "JsonScehmaValidation", error: testResults.errors };
        // Perform update
        const params = {
            TableName: this.getDBName(),
            Key: { ID: cID, wallboardID: wID },
            UpdateExpression: "set " +
                Object.keys(update)
                    .reduce((acc, k, i) => acc + `#config.#${i}=:${i},`, "")
                    .slice(0, -1),
            ExpressionAttributeValues: Object.entries(update).reduce((acc, p, i) => Object.assign(acc, { [":" + i]: p[1] }), {}),
            ExpressionAttributeNames: Object.keys(update).reduce((acc, p, i) => Object.assign(acc, { ["#" + i]: p }), { "#config": "config" }),
        };
        console.log(params);
        // Return response
        try {
            return await this.db.update(params).promise();
        }
        catch (err) {
            throw { code: "DynamoDB", error: err };
        }
    }
    getDBName() {
        return process.env.WALLBOARD_DB;
    }
}
exports.default = db_mapper_1.default.registerModel("wallboard", wallboard_model_1.default, WallboardMapper);
